import type { ApiClient } from '@klareospace/pharos-lib-front-utils';
import { unwrapApiData } from '@klareospace/pharos-lib-front-utils';
import type { OnboardingWizardInfo, PharosApiResponse } from '@klareospace/pharos-lib-types';

// ─── API ──────────────────────────────────────────────────────────────────────

export interface OnboardingWizardApi {
  getOnboardingWizardInfo: () => Promise<OnboardingWizardInfo>;
}

export function createOnboardingWizardApi(client: ApiClient): OnboardingWizardApi {
  return {
    getOnboardingWizardInfo: async (): Promise<OnboardingWizardInfo> => {
      const response = await client.execute<PharosApiResponse<OnboardingWizardInfo>>(() =>
        client.instance.get('/tenants/me/onboarding-wizard-info'),
      );
      return unwrapApiData(response, 'getOnboardingWizardInfo');
    },
  };
}
